

import React, { Component } from "react";
import { CopyToClipboard } from 'react-copy-to-clipboard';

class CopyCell extends Component {
    constructor() {
        super();
        this.state = {

        }
    }

    render() {
        const { value, linkUrl, handleCopy } = this.props;
        return (
            <div>
                {value.key === "copy" ? <CopyToClipboard
                    text={linkUrl}
                    onCopy={handleCopy}
                >
                    {this.props.children}
                </CopyToClipboard> : this.props.children}
            </div>
        )
    }
}
export default CopyCell;


// WEBPACK FOOTER //
// ./src/lib/components/InvitePoster/components/CopyCell.js